<template>
    <div class="equipment-owner-invite page-invite">
        <data-form title="Invite Equipment Owner"
                   tag="equipment-owner-invite"
                   save-button-label="Send"
                   :field-model="fieldModel"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   submit-success-message="Invite sent"
                   submit-error-message="Error inviting user"
                   :submit-success-route="'/'">
        </data-form>
    </div>
</template>

<script>
import {required, email as emailValidator} from 'vuelidate/lib/validators'
import Validation from '@/providers/Validation'

export default {
    name: 'EquipmentOwnerInvite',
    data() {
        return {
            fieldModel: {
                fields: {
                    email: {
                        label: 'Email',
                        type: 'text',
                        validations: {
                            required,
                            email: v => v ? emailValidator(v.toLowerCase()) : true,
                            email_unique: Validation.validateEmailUnique
                        },
                        invalidFeedback: {
                            email_unique: 'This email is already a user in The Yard!'
                        }
                    },
                }
            },
            fieldGroups: [['email']],
        }
    },
    methods: {
        onSubmit(modelInstance) {
            return this.$api.inviteEquipmentOwner(this, modelInstance)
        }
    }
}
</script>
